import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { LanguageService } from '../services/language.service';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RouteLanguageResolver {
  constructor(private languageService: LanguageService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<void> {
    const resourceFiles = route.data['resources'] as string[];
    if (resourceFiles) {
      return this.languageService.resolveResources(resourceFiles);
    }

    return of();
  }
}
